module.exports = __webpack_public_path__ + "img/3.fb726e21.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1386,"height":806,"variants":[{"file":"img/3-480w.dacfcb062921.webp","width":480},{"file":"img/3-960w.9b1581983303.webp","width":960},{"file":"img/3-1386w.11ea2b8797c7.webp","width":1386}]};
}